import { InputBoxProps } from "../../types";
import { Label, Input, ErrorInputText } from "./InputBox.styles";
import HelpIcon from "../../assets/icons/help-circle.svg";
import ReactTooltip from "react-tooltip";
import ChipImage from "./ChipImage";

function InputBox(props: InputBoxProps) {
  const {
    id,
    labelName,
    placeHolderName,
    value,
    handler,
    type,
    style,
    error,
    showTooltip = false,
    toolTipMessage,
  } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Label error={Boolean(error)} htmlFor={id}>
        {labelName}
        {showTooltip && (
          <ChipImage
            styles={{ verticalAlign: "middle", paddingLeft: "8px" }}
            icon={HelpIcon}
            alt="help-icon"
            id={id}
          />
        )}

        {showTooltip && (
          <ReactTooltip
            id={id}
            place="bottom"
            effect="solid"
            className="tooltip-custom"
            backgroundColor={"#636C79"}
            offset={{ left: -5 }}
          >
            {toolTipMessage}
          </ReactTooltip>
        )}
      </Label>
      <Input
        id={id}
        name={id}
        placeholder={placeHolderName}
        value={value}
        onChange={(e) => handler(e)}
        type={type}
        style={{ ...style }}
        error={Boolean(error)}
      />
      {error && <ErrorInputText>{`* ${error}`}</ErrorInputText>}
    </div>
  );
}

export default InputBox;
